import { render, staticRenderFns } from "./LiveDataTable.vue?vue&type=template&id=63cf3043&scoped=true"
import script from "./LiveDataTable.vue?vue&type=script&lang=js"
export * from "./LiveDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cf3043",
  null
  
)

export default component.exports